import * as echarts from 'echarts'
import {
  determineAmPm,
  ECHART_OPTION_GRID_DEFAULTS,
  ECHART_OPTION_X_AXIS_DEFAULTS,
  ECHART_OPTION_Y_AXIS_DEFAULTS
} from './time-series-chart-util'

(function (Drupal, once) {
  'use strict'

  Drupal.behaviors.timeSeriesLineChart = {
    attach: function (context) {
      once('chart-initialized', '.time-series-line-chart', context).forEach(chartElement => {
        // Extract data point string and parse into an array
        const dataAttr = chartElement.dataset.chartData
        if (!dataAttr) return
        const chartKind = (chartElement.dataset.chartKind || 'line').toLowerCase()

        let dataPoints = []
        try {
          dataPoints = JSON.parse(dataAttr)
        } catch (e) {
          return
        }

        if (dataPoints.length === 0) return

        const xWindow = (chartElement.dataset.chartXWindow || 'last15h').toLowerCase()

        // ECharts wants each data point in the format [timestamp, value]
        const chartData = dataPoints.map(point => {
          const t = new Date(point.timestamp).getTime()
          const raw = point.value
          const y = typeof raw === 'number' ? raw : parseFloat(raw)
          return [t, y]
        }).filter(row => Number.isFinite(row[0]) && Number.isFinite(row[1]))

        if (chartData.length === 0) return

        let minTime
        let maxTime
        if (xWindow === 'full') {
          const times = chartData.map(row => row[0])
          minTime = Math.min(...times)
          maxTime = Math.max(...times)
        } else {
          const mostRecentTimeStamp = chartData[chartData.length - 1][0]
          minTime = mostRecentTimeStamp - (15 * 60 * 60 * 1000)
          maxTime = mostRecentTimeStamp
        }

        // Get custom CSS properties
        const lineColor = getComputedStyle(document.documentElement)
          .getPropertyValue('--time-series-chart-red-color').trim() || '#911315'

        // Initialize chart
        const myChart = echarts.init(chartElement)

        const option = {
          animation: false,
          grid: ECHART_OPTION_GRID_DEFAULTS,
          xAxis: {
            ...ECHART_OPTION_X_AXIS_DEFAULTS,
            min: minTime,
            max: maxTime
          },
          yAxis: {
            ...ECHART_OPTION_Y_AXIS_DEFAULTS

          },
          series: [{
            type: chartKind === 'bar' ? 'bar' : 'line',
            data: chartData,
            smooth: chartKind !== 'bar',
            showSymbol: false, // No dots at data points
            lineStyle: {
              color: lineColor,
              width: 4
            },
            itemStyle: {
              color: lineColor
            },
            barMaxWidth: 12
          }],
          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              if (params.length === 0) return ''

              const date = new Date(params[0].value[0])
              const value = params[0].value[1]
              const dateStr = echarts.format.formatTime('MM/dd/yyyy', date)
              const ampm = determineAmPm(date)

              return `${dateStr} ${ampm}<br/>Value: ${value}`
            }
          }
        }

        myChart.setOption(option)
        requestAnimationFrame(() => {
          myChart.resize()
        })

        // Handle resize
        let resizeTimeout
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimeout)
          resizeTimeout = setTimeout(function () {
            myChart.resize()
          }, 100)
        })
      })
    }
  }
})(Drupal, once)
